import { FC, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { routeProvider } from '@/common/utils';
import {
  UserboxDaysLeftWarningText,
  UserboxDaysLeftWarningWrapper
} from './UserboxDaysLeftWarning.styles';
import { MenuToggleContext } from '../../contexts/MenuToggleContext';

interface UserboxDaysLeftWarningProps {
  daysLeft: number;
  planName: string;
}
export const UserboxDaysLeftWarning: FC<UserboxDaysLeftWarningProps> = ({
  daysLeft,
  planName
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { closeMenu } = useContext(MenuToggleContext);

  const goToPayments = async () => {
    await router.push({
      pathname: routeProvider.userAcount,
      query: { tab: 'payments' }
    });

    if (isMobile) {
      closeMenu();
    }
  };

  return (
    <UserboxDaysLeftWarningWrapper>
      <UserboxDaysLeftWarningText>
        <Typography
          variant="body2"
          color="secondary"
          fontSize={theme.typography.pxToRem(12)}
        >
          {planName}
        </Typography>
        &nbsp;&nbsp;
        <Typography
          variant="body2"
          color="error"
          fontSize={theme.typography.pxToRem(12)}
        >{`(${daysLeft} ${t('days left')})`}</Typography>
      </UserboxDaysLeftWarningText>
      <Button
        size="small"
        variant="contained"
        onClick={goToPayments}
        sx={{
          fontSize: theme.typography.pxToRem(12),
          width: 'fit-content'
        }}
      >
        {t('Subscribe')}
      </Button>
    </UserboxDaysLeftWarningWrapper>
  );
};
